const EARTH_RADIUS_MILES = 3959;
const RADIUS_MILES = 50;

function haversineMiles([lng1, lat1], [lng2, lat2]) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_MILES * 2 * Math.asin(Math.sqrt(a));
}

// areas: [{ id, name, center: [lng, lat], threshold }]
// coordinates: [[lng, lat], ...] from the server
// Returns areas with a real `fans` array (one entry per nearby coordinate) instead of the hardcoded colors.
export function clusterFansIntoAreas(areas, coordinates) {
  return areas.map((area) => {
    const nearby = coordinates.filter(
      (coord) => haversineMiles(area.center, coord) <= RADIUS_MILES
    );
    return {
      ...area,
      fans: nearby.map(() => '#e63946'),
    };
  });
}